import { render } from "./promo.vue?vue&type=template&id=6ee7789e&scoped=true"
import script from "./promo.vue?vue&type=script&lang=js"
export * from "./promo.vue?vue&type=script&lang=js"

import "./promo.vue?vue&type=style&index=0&id=6ee7789e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ee7789e"]])

export default __exports__